<script>
import { Line as ReportDetailGraph } from "vue-chartjs";

export default {
  extends: ReportDetailGraph,
  props: {
    height: {
      type: String,
      default: null,
    },
    graph_data: {
      type: Object,
      default: null,
    },
    done_data: {
      type: Boolean,
      default: true,
    },
    reRender: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    datas() {
      return {
        labels: this.graph_data.labels,
        datasets: [
          {
            type: "bar",
            label: "投稿数",
            borderColor: "#427eff55",
            backgroundColor: "#427eff55",
            barThickness: 5,
            data: this.graph_data.post_num,
            yAxisID: "transparent",
          },
          {
            label: "エンゲージメント数",
            borderColor: "#0095f6",
            backgroundColor: "",
            borderWidth: 2,
            data: this.graph_data.eg_data,
            pointRadius: 5,
            pointBackgroundColor: "#0095f6",
            yAxisID: "left",
          },
          {
            label: "コメント数",
            borderColor: "#0095f6",
            backgroundColor: "transparent",
            borderWidth: 2,
            data: this.graph_data.comments_data,
            pointRadius: 0,
            pointBackgroundColor: "#0095f6",
            yAxisID: "left",
          },
          {
            label: "エンゲージメント率",
            borderColor: "rgb(55, 191, 235)",
            backgroundColor: "transparent",
            borderWidth: 2,
            data: this.done_data
              ? this.graph_data.egr_data_done
              : this.graph_data.egr_data,
            pointRadius: 5,
            pointBackgroundColor: "#54ccdb",
            yAxisID: "right",
          },
        ],
      };
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: "nearest",
          intersect: false,
          titleMarginBottom: 10,
          xPadding: 10,
          yPadding: 10,
          bodySpacing: 10,
        },
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 0,
            bottom: 0,
          },
        },
        legend: {
          display: true,
          position: "top",
          align: "end",
          labels: {
            padding: 10,
            fontSize: 10,
            boxWidth: 20,
          },
        },
        scales: {
          xAxes: [
            {
              //x軸設定
              display: true, //表示設定
              ticks: {
                padding: 5,
                fontColor: "#aaa",
              },
              gridLines: {
                // このオプションを追加
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              id: "left", // Y軸のID
              type: "linear", // linear固定
              position: "left", // どちら側に表示される軸か？
              ticks: {
                padding: 5,
                fontColor: "#aaa",
                min: this.graph_data.minmax.engagement_count_min,
                max: this.graph_data.minmax.engagement_count_max,
              },
            },
            {
              id: "right",
              type: "linear",
              position: "right",
              gridLines: {
                // このオプションを追加
                drawOnChartArea: false,
              },
              ticks: {
                padding: 5,
                fontColor: "#aaa",
                min: this.done_data
                  ? this.graph_data.minmax_done.average_engagement_rate_min
                  : this.graph_data.minmax.average_engagement_rate_min,
                max: this.done_data
                  ? this.graph_data.minmax_done.average_engagement_rate_max
                  : this.graph_data.minmax.average_engagement_rate_max,
              },
            },
            {
              id: "transparent",
              display: false,
              ticks: {
                max: this.graph_data.minmax.post_num_max,
              },
            },
          ],
        },
      };
    },
  },
  mounted() {
    this.graphColor();
    this.renderChart(this.datas, this.options);
  },
  methods: {
    graphColor() {
      var gradient = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 300);
      gradient.addColorStop(0, "#0095f699");
      gradient.addColorStop(1, "#54ccdb11");
      this.datas.datasets[1].backgroundColor = gradient;
    },
  },
  watch: {
    datas() {
      this.graphColor();
      this.renderChart(this.datas, this.options);
    },
    reRender() {
      this.graphColor();
      this.renderChart(this.datas, this.options);
    },
  },
};
</script>